@for (notification of notifications; track notification) {
  <div
    class="fixed right-2 cursor-pointer px-2 mb-3 z-[101] toaster {{ notification.type | lowercase }}"
    [class.collapsed]="notification.collapsed"
    [style.top]="178 + 45 * ($index + 0.5) * 1.25 + 'px'"
  >
    <div class="flex items-center">
      <div class="content-container truncate w-full" [routerLink]="[notification.url]">
        <div class="flex items-center gap-1">
          @if (languageService.language$ | async; as language) {
            <p
              class="content"
              [innerHTML]="notification.collapsed ? $safeNavigationMigration(notification.heading?.[language]) : $safeNavigationMigration(notification.content?.[language])"
            ></p>
          }
        </div>
      </div>
      <button
        type="button"
        class="w-auto toaster-toggle"
        mat-icon-button
        (click)="notification.collapsed = !notification.collapsed"
      >
        <gan-lucid-icon iconId="chevron-right" />
      </button>
    </div>
  </div>
}
